export const LinkToAnalysisPage = "#noodler";
// export const LinkToCreditsPage = "#credits";
export const LinkToTipJarPage = "#tipjar";
export const LinkToPrivacyPage = "#privacy";